let e;var a;(a=e||(e={})).Masked="masked",a.Unmasked="unmasked",a.Disabled="disabled",a.Na="na",Object.freeze(a);export{e as WhenCollectionToggleOffAction};
